/** Display status labels in uppercase. */
export const formatStatusLabel = (status) => {
  if (status == null || status === '') return '—';
  const value = String(status).trim();
  if (value === '—' || value === '-') return value;
  return value.toUpperCase();
};
